var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"chart"}},[_c('apexchart',{attrs:{"width":"65px","height":"65px","type":"radialBar","options":_vm.chartOptions,"series":_vm.data}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }